import qs from 'qs'
import { Map } from 'immutable'
import { AsyncState, loadingAsyncState, unloadedAsyncState } from 'widgets-for-react'
import { Block } from '../wordpress/types_and_parser/standard_blocks.gen'
import { Page } from '../cms/page/types.gen'
import { TransformStandardBlock } from '../wordpress/wordpress_to_cms.gen'
import { WordPress } from '../wordpress/wordpress_api'
import { CustomBlock } from '../wordpress/types_and_parser/custom_blocks.mod'
import { ExtraParameters } from '../cms/router/type.gen'
import { PublicSite_CustomPageData } from './application.mod'


export const ERROR_PAGE_SLUG = '/not-found'


export const get_page = (
  slug: string,
  extra_parameters: ExtraParameters
): AsyncState<Page<CustomBlock, Block, PublicSite_CustomPageData>> =>
  loadingAsyncState(_ => {

    var params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    if (params.preview || params.preview_id) {

      let preview_id = params.preview_id || params.page_id || params.p
      slug = `/previews/${preview_id}`
    }
    if (!slug.endsWith('/embed/')) {
      slug += "/embed/"
    }

    return WordPress.api()
      .current(slug)
      .then(response => {

        return response.data && response.data.acf
          ? {
            kind: 'result',
            value: {
              ...response.data,
              blocks: response.data.blocks ? response.data.blocks.map(b => TransformStandardBlock(b)) : [],
              extra_data: { ...loadExtraPostData(response.data), extra_params: extra_parameters },
            },
            status: 200
          }
          : { kind: 'failed', status: 404 }
      })
      .catch(e => {
        if (slug != ERROR_PAGE_SLUG) {
          return WordPress.api()
            .current(ERROR_PAGE_SLUG)
            .then(response => {
              return response.data && response.data.acf
                ? {
                  kind: 'result',
                  value: {
                    blocks: response.data.blocks ? response.data.blocks.map(b => TransformStandardBlock(b)) : [],
                    extra_data: { ...loadExtraPostData(response.data), extra_params: extra_parameters }
                  },
                  status: 200
                }
                : { kind: 'failed', status: 404 }
            })
            .catch(e2 => {
              console.error(e2)
              return e2
            })
        }
        else {
          console.error(e)
          return e
        }
      })
  })

export function get_options(id: string): AsyncState<WordPress.OptionsResponse> {
  return loadingAsyncState<WordPress.OptionsResponse>(_ =>
    WordPress.api()
      .options(id)
      .then(response => {
        return response.data
          ? { kind: 'result', status: 200, value: response.data }
          : {
            kind: 'failed',
            status: 404
          }
      })
  )
}

export function asyncPost<PT>(id: number, lang: string): AsyncState<WordPress.PostTypeResponse> {
  return loadingAsyncState<WordPress.PostTypeResponse>(_ =>
    WordPress.api()
      .anypost(id)
      .then(response =>
        response.data ? { kind: 'result', status: 200, value: response.data } : { kind: 'failed', status: 404 }
      )
  )
}

export function asyncPosts(args?: WordPress.PostRequestArguments): AsyncState<Array<WordPress.PostTypeResponse>> {
  return loadingAsyncState<Array<WordPress.PostTypeResponse>>(_ =>
    WordPress.api<WordPress.PostTypeResponse>()
      .select('post')
      .where(args)
      .getMultiple()
      .then(response =>
        response.data
          ? { kind: 'result', status: 200, value: response.data }
          : {
            kind: 'failed',
            status: 404
          }
      )
  )
}

export function loadExtraPostData(post: WordPress.PostTypeResponse): PublicSite_CustomPageData {
  let posts = Map<number, AsyncState<WordPress.PostTypeResponse>>()
  let latest_articles = unloadedAsyncState<Array<WordPress.PostTypeResponse>>()
  let news: WordPress.Overview<'news'>;
  let stories: WordPress.Overview<'story'>;
  const searchParams: URLSearchParams = new URL(location.href).searchParams

  var params = qs.parse(window.location.search, { ignoreQueryPrefix: true })
  let category = params.category as any
  let year = params.year as any

  const currentPage = searchParams.has('page') ? parseInt(searchParams.get('page')) : 1

  const reqArgs = {
    per_page: 12,
    page: currentPage
  }

  if (post.type == 'page' && post.template == 'news-overview') {

    const categoryFilter = {
      news_taxonomy: category
    }
    const yearFilter: WordPress.PostRequestArguments = year ? {
      after: `${year}-01-01T00:00:00+01:00`,
      before: `${parseInt(year) + 1}-01-01T00:00:00+01:00`
    } : {}

    news = {
      current_page: searchParams.has('page') ? parseInt(searchParams.get('page')) : 1,
      kind: 'news',
      categories: loadingAsyncState<Array<WordPress.TaxonomyResponse>>(_ =>
        WordPress.api<WordPress.TaxonomyResponse>()
          .terms('news_taxonomy')
          .then(response => response.data
            ? {
              kind: 'result',
              status: 200,
              value: response.data
            }
            : {
              kind: 'failed',
              status: 404
            }
          )
      ),
      years: loadingAsyncState<Array<number>>(_ =>
        WordPress.api<number>()
          .years('news')
          .then(response => response.data
            ? {
              kind: 'result',
              status: 200,
              value: response.data
            }
            : {
              kind: 'failed',
              status: 404
            }
          )
      ),
      async: loadingAsyncState<WordPress.OverviewResponse>(_ =>
        WordPress.api<WordPress.NewsArticleResponse>()
          .select('news')
          .where({
            ...reqArgs,
            ...categoryFilter,
            ...yearFilter
          })
          .getMultiple()
          .then(response => response.data
            ? {
              kind: 'result', status: 200, value: {
                total_pages: response.headers["x-wp-totalpages"],
                total_articles: response.headers["x-wp-total"],
                kind: 'news',
                posts: response.data
              }
            }
            : {
              kind: 'failed',
              status: 404
            }
          )
      )
    }
  }

  if (post.type == 'page' && post.template == 'story-overview') {
    const categoryFilter = {
      story_taxonomy: category
    }

    stories = {
      current_page: searchParams.has('page') ? parseInt(searchParams.get('page')) : 1,
      kind: 'story',
      categories: loadingAsyncState<Array<WordPress.TaxonomyResponse>>(_ =>
        WordPress.api<WordPress.TaxonomyResponse>()
          .terms('story_taxonomy')
          .then(response => response.data
            ? {
              kind: 'result',
              status: 200,
              value: response.data
            }
            : {
              kind: 'failed',
              status: 404
            }
          )
      ),
      async: loadingAsyncState<WordPress.OverviewResponse>(_ =>
        WordPress.api<WordPress.StoryResponse>()
          .select('story')
          .where({
            ...reqArgs,
            ...categoryFilter
          })
          .getMultiple()
          .then(response => response.data
            ? {
              kind: 'result', status: 200, value: {
                total_pages: response.headers["x-wp-totalpages"],
                total_articles: response.headers["x-wp-total"],
                kind: 'story',
                posts: response.data,
              }
            }
            : {
              kind: 'failed',
              status: 404
            }
          )
      )
    }
  }

  return {
    posts,
    post,
    latest_articles,
    stories,
    news
  }
}